import Configuration from '../ConfigurationOverview.vue';

export default {
  path: '/configuration',
  name: 'Configuration',
  component: Configuration,
  meta: { menuItemName: 'Configuration' }
};
